/*
    ttl = titulo
    stl = subtitulo
    btn = boton
    lbl = label
    cmp = campo
    msg = mensaje
*/

export default ({
    // ModuloElementos
    ttlLecturaQR: 'Leer el QR del elemento',
    btnLecturaQR: 'Registra por QR',
    ttlIdentificacionQR: 'Ingresa el número de identificación de la persona',
    btnRegistrar: 'Registrar',
    lblIdentificacion: 'Ejemplo: 1234567890',
    lblFecha: 'Fecha: ',
    lblHora: 'Hora: ',
    btnSiguiente: 'Siguiente',
    btnFinalizarRegistro: 'Finalizar Registro',
    lblNroIdentificacion: 'ID',
    lblNombreVisitante: 'Nombre de Persona',
    btnTomarFoto: 'Tomar Foto',
    ttlValidaInfo: 'Valida la información registrada',
    ttlregistroSalidaEntrada: 'Realiza el registro de la Salida/Entrada',
    stlInfoVisitante: 'Información de persona',
    stlInfoVehiculos: 'Información de elementos asociados',
    stlInfoNuevoElemento: 'Presiona el botón para añadir elemento',
    stlTipoElemento: 'Tipo Elemento',
    stlMarca: 'Marca',
    stlColor: 'Color',
    btnVerQR: 'Ver QR',
    btnCambiarQR: 'Cambiar QR',
    ttlNuevoElemento: 'Nuevo Elemento',
    btnAñadir: 'Añadir',
    cmpTipoElementoObligatorio: 'Tipo Elemento*',
    cmpMarcaObligatorio: 'Marca*',
    cmpColorObligatorio: 'Color*',
    cmpQRObligatorio: 'Seleccione el icono para capturar la lectura QR*',
    lblMarca: 'Ejemplo: Shimano',
    lblColor: 'Ejemplo: Rojo',
    stlInfoRegistro: 'Información de registro',
    cmpProcesoObligatorio: 'Selecciona el proceso a realizar*',
    cmpObsObligatorio: 'Observaciones *',
    cmpObs: 'Observaciones',
    lblQrLeido: 'El Qr ha sido procesado',
    lblObs: 'Ejemplo: Escriba cualquier observaciones general de la entrada o salida',
    lblAnexos: 'Anexos',
    ttlCodigoQR: 'Código QR',
    msgMaxFotos: 'Notificación: Unicamente puede tomar máximo XXX Fotos',
    ttlTomaFotos: 'Toma de Fotografias',
    msgQRLeido: 'EL QR ya ha sido agregado',
    msgQRNoExistente: 'El QR no existe o no esta relacionado a ninguna persona',
    msgQRNoPersona: 'El QR no pertenece a la persona, registra a nombre de XXX identificado con YYY que esta haciendo el registro',
    msgQRNoDisponible: 'El Código QR se encuentra inactivo',
    msgNroIdentificacionNovalido: 'El número de identificación no válido',
    NuevoVisitante: 'Nueva persona',
    msgVisitanteNoExistente: 'Persona no registrada en el sistema',
    cmpCedulaObligatorio: 'No identificación*',
    lblCedula: 'Ejemplo: 1234567890',
    cmpNombreVisitanteObligatorio: 'Nombre de la persona*',
    lblNombreVisitante2: 'Escribe el nombre',
    ttlNuevoVisitante: 'Nueva Persona',
    cmpDetalle: 'Detalle*',
    lblDetalle: 'Escriba alguna descripción del elemento',
    msgFormularioElemento: 'Recuerde diligenciar toda la información obligatoria',
    msgFaltanElementosVisitantes: 'Faltan elementos o persona por validar',
    lblTipoVisitante:'Tipo de Persona',
    cmpTipoVisitanteObligatorio: 'Tipo de Persona*',
    textoElementosSeleccionar: 'Selecciona un elemento para continuar con el proceso de registro',
    cmpAccesoObligatorio: 'Acceso*',
    msgFaltanDatosregistro: 'Faltan datos de registro por diligenciar',
    ttlFotos: 'Fotos',
    msgErrorEnvio: 'Error de envió  de información. Intente nuevamente',
    ttlEditarElemento: 'Editar Elemento',
    lblEditar: 'Editar',
    ttlResumenElemento: 'Resumen de elemento',
    btnGuardar: 'Guardar',
    btnCancelar: 'Cancelar',
    btnCerrar: 'Cerrar',
    lblAgregarObservacion: 'Añade acá tus observaciones',
    lblAceptarPolitcasDatos: 'He leído y estoy de acuerdo con la politica de privacidad de datos.',
    lblUrlPoliticasDato: "www.politicadatos.com",
    cmpEstado: "Estado",
    lblPersonaDentro: "La persona ya se encuentra dentro de las instalaciones",
    lblIngresoOn: "Ya tiene ingreso",
    lblIngresoOff: "No tiene ingreso",
    ttlRondasAsignadas: "Rondas asignadas",
    lblPendientes:"Pendientes",
    lblFinalizados:"Finalizados",
    lblPuntos:"Puntos",
    lblTipoInicio:"Inicio",
    btnFinalizarRonda:"Finalizar ronda",
    btnMarcarPunto:"Marcar punto",
    btnEnviar:"Enviar",
    btnConfirmaContinuar:"Si, continuar",
    ttlRondaIncompleta: 'Ronda incompleta',
    msgFinalizarRondaIncompleta: 'Parece que te faltó cerrar algunos puntos. ¿Deseas continuar?',
    msgRazonesFinalizarRondaIncompleta: 'Añade las razones por el cuál no pudiste cerrar todos los puntos de la ronda...',
    ttlBienHecho: '¡Bien Hecho!',
    msgRondaFinalizada: 'Has cerrado satisfactoriamente la ronda',
    lblQueDeseaReportar: '¿Qué desea reportar?',
    ttReporteNovevdadIncidente: 'Registrar novedad o incidente',
    lblPunto:"Punto",
    msgRondasFinalizadas: "¡Genial, has finalizado las rondas!",
    msgSinRondasPendientes: "Has terminado con éxito todas las rondas para hoy. ¡Excelente trabajo!",
    msgRondasAunSinFinalizar: "Aún no has finalizado ninguna ronda",
    msgCompletaRondasParaFinalizar: "¡Aún no has finalizado ninguna ronda! Completa las rondas para mantener la seguridad al máximo.",
    lblTipificacionGeneral:"Tipificacion General",
    lblTipificacionEspecifica:"Tipificacion Especifica",
    cmpAgregarObservaciones: 'Añade tus observaciones',
    ttlRondaEnCurso: 'Ronda en curso',
    ttlRondaBloqueada: 'Ronda bloqueada',
    msgRondaBloqueadaEnEspera: "La ronda está actualmente bloqueada porque acabas de completar la ronda anterior. Por favor, espera unos minutos para que se habilite.",
    msgRondaBloqueadaPorRondaEnProgreso: "No es posible iniciar una nueva ronda en este momento. Tienes una ronda en progreso que debe ser finalizada primero.",
    msgRondaBloqueadaHoraInicio: "No es posible iniciar esta ronda. Por favor, espera a la hora de inicio para que se habilite.",
    msgRondaBloqueadaIniciadaDesdeOtroUsuario: "Otra usuario ya esta realizando esta ronda. Puedes avanzar con la siguiente ronda.",
    ttlObteniendoGps: 'Obteniendo ubicación GPS',
    msgObteniendoGps: 'Esto puede tomar unos segundos según tu dispositivo',
    ttlTurnoEntrada: 'Reportar entrada',
    ttlTurnoSalida: 'Reportar salida',
    lblCedulaCiudadania: 'Cedula de ciudadanía',
    msjCedulaCiudadania: 'Ingresa tu cedula de ciudadanía',
    btnVerificar: 'Verificar', 
    ttlArriboDuplicado: 'Arribo ya registrado',
    ttlSalidaDuplicada: 'Salida ya registrada',
    msjArriboDuplicado: 'Ya existe un arribo registrado para la cedula xxx hoy.',
    msjSalidaDuplicado: 'Ya existe una salida registrada para la cedula xxx hoy.',
    ttlNuevaEntrada: 'Registro nuevo y confirmación de entrada',
    ttlNuevaSalida: 'Registro nuevo y confirmación de salida',
    lblDatosBasicos: 'Datos básicos',
    lblNombre: 'Nombre',
    msgNombre: 'Ingrese su nombre completo ',
    btnRegistrarConfirmar: 'Registrar y confirmar ', 
    lblDatosArribo: 'Lugar de arribo',
    lblCliente: 'Cliente',
    lblSede: 'Sede',
    lblPuesto: 'Puesto',
    msgCliente: 'Elige un Cliente',
    msgSede: 'Elige una Sede',
    msgPuesto: 'Elige un Puesto',
    lblNovedades: 'Novedades',
    lblTipoNovedades: 'Tipo de Novedad',
    msgNovedad: 'Elige el tipo de novedad',
    lblDatosAsociados: 'Datos asociados',
    msgSinInternet: 'Se han identificado problemas con tu conexion a internet.',
    btnEntrada: 'Entrada',
    btnSalida: 'Salida',
    ttlRegistroTurno: 'Registro de turno',
    ttlUsuarioRegistrado: 'Usuario Registrado',
    msjUsuarioRegistrado: 'Ya existe un usuario registrado para la cedula xxx.',
    ttlArriboRegistrado: '¡Arribo confirmado!',
    ttlSalidaRegistrado: '¡Salida confirmada!',
    msjArriboRegistrado: 'Su identidad ha sido verificada y el arribo ha sido registrado',
    msjSalidaRegistrado: 'Su identidad ha sido verificada y la salida ha sido registrada',
    lblPuntosMarcacion: 'Puntos de marcación',
    lblHoraProgramada: 'Hora programada',
    lblBuscarRondas: 'Buscar ronda',
    lblBuscarPunto: 'Buscar punto',
    lblHoraEjecutada: 'Hora ejecutada',
    lblFechaHoraMarcacion: 'Fecha de marcación',
    lblTipo: 'Tipo',
    msgSinResultados: 'No se encontraron resultados',
    msgNoSeProcesoSolicitud: 'No se pudo procesar solicitud'
})